import { Box, Flex, Spacer} from "@chakra-ui/react";
import InputSelect from "components/InputSelect/InputSelect";
import { LabelGroup } from "pages/RefProductInter/LabelGroup";
import React, { useEffect, useState, useRef } from "react";
import { ButtonStyled } from "styled/Buttons.styled";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import { GetWeihingButton } from "../FormWeighingMachine.js/GetWeihing";
import { InputWithLabel } from "components/Input/InputFakeCustoms";

export const ForGetWeihighing = ({
  values,
  handleInputChange,
  tabIndex,
  setTabIndex,
  set,
  children
}) => {
  const { name_typeTransport, weight, automatic, type_weight, weighing_manual } = values;

  const [openAlert] = AlertErrorAlert();
  const [typeWeihingState, setTypeWeihingState] = useState(null);
  const [loading, setLoading] = useState(false);
  const [weightData, setWeightData] = useState(null);
  const [shouldShowWeight, setShouldShowWeight] = useState(true);
  const [weightDataSpushed, setWeightDataSpushed] = useState(null);
  const isManualEditRef = useRef(false);

  const typeWeihing = [
    {
      value: "Tara",
      label: "Tara"
    },
    {
      value: "Bruto",
      label: "Bruto"
    }
  ];

  useEffect(() => {
    const tipodato = typeof set;
    if (typeWeihingState && typeWeihingState.value && tipodato === "function") {
      set({ ...values, type_weight: typeWeihingState.value });
    }
  }, [typeWeihingState, set]);

  useEffect(() => {
    // Solo actualizar desde weightData si:
    // 1. weightData existe
    // 2. No es una edición manual (verificado por isManualEditRef)
    // 3. automatic es true (peso viene de la báscula)
    // 4. El peso actual es diferente al peso de weightData (evita actualizaciones innecesarias)
    if (weightData && !isManualEditRef.current && automatic === true && weight !== weightData.weight) {
      set({ ...values, weight: weightData.weight });
    }
  }, [weightData, automatic]); // Removido 'values' y 'set' de dependencias para evitar loops

  // Función para mostrar el peso
  const handleShowWeight = () => {
    if (weightDataSpushed) {
      console.log("Peso a mostrar:", weightDataSpushed);
      // Resetear el flag de edición manual cuando se obtiene peso de la báscula
      isManualEditRef.current = false;
      setWeightData(weightDataSpushed);
      // Preservar todos los valores existentes, solo actualizar weight y automatic
      set({ ...values, weight: weightDataSpushed.weight, automatic: true });
    }
    else {
      console.log("No hay peso para mostrar");
    }
  };

  // Listener para la tecla F8
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'F8') {
        event.preventDefault();
        handleShowWeight();
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [weightData, values, set]);

  const validatPesoyType = () => {
    if (
      type_weight === "" ||
      type_weight === null ||
      type_weight === undefined
    ) {
      openAlert("El tipo de peso es requerido", "error");
    } else if (weight === "" || weight === null || weight === undefined) {
      openAlert("El peso es requerido", "error");
    } else {
      setTabIndex(tabIndex + 1);
    }
  };

  const HandleWeightInputChange = (e) => {
    const newWeightValue = e.target.value;
    // Marcar como edición manual ANTES de cualquier actualización
    isManualEditRef.current = true;
    // Limpiar weightData INMEDIATAMENTE para evitar que el useEffect lo sobrescriba
    setWeightData(null);
    // Actualizar el valor del peso usando handleInputChange
    handleInputChange(e);
    // Actualizar automatic: false y el peso
    set({ ...values, automatic: false, weight: newWeightValue });
    // Mantener isManualEditRef en true mientras el usuario esté editando
    // Solo se reseteará cuando se obtenga un nuevo peso de la báscula
  };

  return (
    <>
      {tabIndex !== 2 && (
        <div style={{ width: "100%" }}>
          <InputSelect
            tag={"Tipo de peso"}
            data={typeWeihing}
            set={setTypeWeihingState}
            value={{value:values?.type_weight, label:values?.type_weight} || typeWeihingState} //muestra de manera condicional el valor que llega de back o el valor que el usuario seleccione
          />
        </div>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between"
        }}
      >
        {tabIndex !== 2 && (
          <LabelGroup
            name={"name_typeTransport"}
            value={name_typeTransport}
            onChange={handleInputChange}
            tag={"Tipo de transporte"}
            size={40}
            desicion={true}
          />
        )}

        {tabIndex === 2 && (
          <LabelGroup
            name={"type_weight"}
            value={type_weight}
            onChange={handleInputChange}
            tag={"Tipo de peso"}
            size={45}
            desicion={true}
          />
        )}
        <Box display={"flex"} w={`${tabIndex !== 2 ? 50 : 45}%`}>
          <InputWithLabel
            p={1}
            mr={3}
            fontWeight={0}
            _focus={{
              outline: "none"
            }}
            borderBottom={"none"}
            border={"2px solid #bababa"}
            name={"weight"}
            value={weight}
            onChange={HandleWeightInputChange}
            labelText={"Peso"}
            bg={"rgba(242, 242, 242, 0.1)"}
            readOnly={weighing_manual === 0 ? true : false}
            cursor={weighing_manual === 0 ? "no-drop" : "auto"}
          />
          { name_typeTransport !== "" && tabIndex !== 2 && (
            <>
             {/* boton para mostrar el peso de la báscula */}
             {shouldShowWeight && (
                <ButtonStyled
                  bgColor={"#28a745"}
                  onClick={handleShowWeight}
                  style={{ marginLeft: "8px", marginTop: "24px !important" }}
                >
                  Obtener Peso
                </ButtonStyled>
              )}
              {/* fin de boton para mostrar el peso de la báscula */}
              <GetWeihingButton
                loading={loading}
                setLoading={setLoading}
                executeFunction={(InweightData) => {
                  console.log("Peso recibido automáticamente:", InweightData);
                  setWeightDataSpushed(InweightData);
                }}
              />
            </>
          )}
        </Box>
      </div>

      {children}
      {tabIndex !== 2 && (
        <Flex>
          <ButtonStyled
            bgColor={"#bababa"}
            onClick={() => setTabIndex(tabIndex - 1)}
          >
            Volver
          </ButtonStyled>
          <Spacer />
          <ButtonStyled bgColor={"#3182CE"} onClick={validatPesoyType}>
            Siguiente
          </ButtonStyled>
        </Flex>
      )}
    </>
  );
};
